// extracted by mini-css-extract-plugin
export var group = "AppPreview-module--group--NgVVi";
export var group__figure = "AppPreview-module--group__figure--MDE7j";
export var group__paragraph = "AppPreview-module--group__paragraph--iJBNv";
export var group__text = "AppPreview-module--group__text--G0oW2";
export var group__title = "AppPreview-module--group__title--hqLzY";
export var title = "AppPreview-module--title--OGzlz";
export var video = "AppPreview-module--video--YKRjt";
export var wrapper = "AppPreview-module--wrapper--l2Gq8";